module.exports = __webpack_public_path__ + "static/media/Hazard Information.b86a388e.png";